import { ExternalLink, MapPin, Navigation, PackageCheck } from "lucide-react";
import { TrackingMap } from "@/components/tracking/TrackingMap";

const COPY = {
  unassigned: ["Delivery not assigned yet", "Tracking will appear after the shop assigns a rider or courier."],
  ready: ["Rider assigned", "The rider has not started location sharing yet."],
  waiting: ["Waiting for GPS", "The rider is sharing, but no current location has arrived yet."],
  live: ["Recent rider location", "Location updates appear while the rider’s delivery page is active."],
  paused: ["Location sharing paused", "No rider position is being shared right now."],
  stale: ["Location update unavailable", "The last GPS reading is over two minutes old. No old position is shown as live."],
  courier: ["Courier delivery", "Use the courier’s website for updates. Courier GPS is not connected to this map."],
  ended: ["Delivery tracking closed", "Rider location is no longer available for this order."],
};

export const TrackingStatus = ({ data }) => {
  const [title, detail] = COPY[data.state] || COPY.unassigned;
  const Icon = data.state === "ended" ? PackageCheck : data.position ? Navigation : MapPin;
  return (
    <section className="min-w-0 space-y-6" data-testid="tracking-status-section">
      <div className="flex items-start gap-3 border-y border-ragi/15 py-5">
        <Icon className="mt-1 h-6 w-6 shrink-0 text-terracotta" aria-hidden="true" />
        <div className="min-w-0"><h2 className="font-display text-lg font-semibold" data-testid="tracking-status-title">{title}</h2><p className="mt-1 text-sm text-muted-foreground" data-testid="tracking-status-description">{detail}</p></div>
      </div>
      {data.position && <TrackingMap position={data.position} />}
      {data.state === "courier" && <div className="space-y-3" data-testid="courier-tracking-details">
        <p className="break-words font-semibold" data-testid="courier-name">{data.courier_name}</p>
        <p className="break-all font-mono text-sm" data-testid="courier-tracking-number">Tracking number: {data.tracking_number}</p>
        <a href={data.tracking_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-ragi px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-ragi-dark" data-testid="courier-tracking-link">Track with courier<ExternalLink className="h-4 w-4" /></a>
      </div>}
    </section>
  );
};